import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { popupOpenClose } from '../../action/action'
import { popupColorSet } from '../../JS/setColors'

class NIHPopup extends Component {
    onNoClick = () => {
        this.props.popupOpenClose(false, "");
    }

    componentDidMount() {
        popupColorSet(this.props.menuColor);
    }
    render() {
        return (
            <div class="overlay">
                <div id="svc" className="overlay-body">
                    <div className="overlay-close" onClick={this.onNoClick}>
                        <i class="fa fa-close" style={{ color: "white" }}></i>
                    </div>
                    <div className="response" style={{ color: "inherit" }}>
                        {this.props.popupMsg}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        notInHotelPopup: state.store.notInHotelPopup,
        popupMsg: state.store.popupMsg,
        menuColor: state.store.home.MenuColor
    }
}

export default connect(
    mapStateToProps,
    {
        popupOpenClose
    }
)(NIHPopup);